<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.user-infor-popover.el-popper[x-placement^="bottom"] {
  margin-top: 24px;
  max-width: 296px;
  min-width: 152px;
  padding: 16px 0;

  .user-infor {
    &__item {
      border-bottom: solid 1px #eaeaea;
      font-size: 14px;
      padding: 15px 24px;
      position: relative;

      &::after {
        clear: both;
        content: "";
        display: block;
      }

      .label {
        color: #666;
        float: left;
        margin-right: 8px;

        &.en {
          margin-right: 0;
          min-width: 60px;
        }
      }

      .infor {
        color: #333;
        margin-left: 8px;
      }

      &:first-child {
        padding-top: 0;
      }
    }

    &__btn {
      padding: 15px 24px 0 24px;
      padding-top: 0;
      text-align: center;

      .el-button--primary.is-plain {
        background: #fff;
        border-color: #28e;
        color: #28e;
        width: 100%;

        &:hover {
          background: #28e;
          color: #fff;
        }
      }

      &-logout {
        margin-top: 16px;

        .el-button--primary.is-plain {
          border: solid 1px #d8d8d8;
          color: #515152;

          &:hover {
            border-color: #28e;
          }
        }
      }
    }
  }
}

</style>
<template>
    <div class="app-header">
        <div class="app-header__main" :style="{width: layoutWidth}">
            <div class="logo">
                <router-link to="/">
                    <!-- <i class="iconfont icon-geely_svg logo-icon"></i> -->
                    <!-- <i class="geelyIcon geely-iconlogo logo-icon"></i> -->
                    <img class="logo-icon" src="@/assets/images/tu-logo.svg" @click="reloadPage">
                </router-link>
                <span v-if="pageMode === '1'" class="logo-model">预览模式</span>
            </div>
            <div class="handler app-flex">
                <template v-if="currentUserInfor">
                    <div class="user-box app-flex app-flex-o">
                        <div class="head">
                            <img class="head-img" :src="avatar" v-if="avatar">
                        </div>
                        <el-popover placement="bottom" width="auto" trigger="hover" popper-class="user-infor-popover">
                            <ul class="user-infor">
                                <li class="user-infor__btn">
                                    <el-button type="primary" size="medium" plain @click="goEditPwd">{{$t('home.editPwd')}}</el-button>
                                </li>
                                <li class="user-infor__btn user-infor__btn-logout" v-if="isInside">
                                    <el-button type="primary" size="medium" plain @click="logout" v-t="'home.logOut'"></el-button>
                                </li>
                            </ul>
                            <template slot="reference">
                                <a href="javascript:;" class="userName">{{currentUserInfor ? currentUserInfor.userName : '--'}}<i class="el-icon-caret-bottom"></i></a>
                            </template>
                        </el-popover>
                    </div>
                    <!-- <div class="job">
                        <span class="job-label" v-if="!isEmp">吉利员工</span>
                    </div> -->
                </template>
                <template v-else>
                    <div class="app-flex app-flex-o">
                        <el-button class="login-link" size="medium" :loading="loginLoading" v-if="loginLoading">
                        </el-button>
                        <el-button class="login-btn" size="medium" @click="login" v-else>
                            <span>{{$t('home.login')}}</span>
                        </el-button>
                    </div>
                </template>
                <div class="lang-box">
                    <a href="javascript:;" :class="{'active': currentLang === 'zh-CN'}" @click="changeLang('zh-CN')" class="lang-box-item">中</a>
                    <a href="javascript:;" class="lang-box-item lang-box-item-line"></a>
                    <a href="javascript:;" :class="{'active': currentLang === 'en'}" @click="changeLang('en')" class="lang-box-item">En</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { GetSearchValue } from '@/utils'

export default {
  name: 'appHeader',
  data () {
    return {
      userInfor: [{
        key: 'comName',
        label: '公司',
        val: ''
      }, {
        key: 'position',
        label: '岗位',
        val: ''
      }, {
        key: 'phone',
        label: '手机',
        val: ''
      }, {
        key: 'email',
        label: '邮箱',
        val: ''
      }]
    }
  },
  computed: {
    loginLoading () {
      return this.$store.state.global.loading
    },
    layoutWidth () {
      return this.$store.state.global.layoutWidth + 'px'
    },
    currentLang () {
      return this.$i18n.locale
    },
    currentUserInfor () {
      return this.$store.state.global.loginInfo
    },
    avatar () {
      return this.currentUserInfor.avatar
    },
    isEmp () {
      return this.currentUserInfor.isEmp
    },
    editPwdUrl () {
      return process.env.VUE_APP_AQ_URL + '/#/editPwd/1'
    },
    userInforNew () {
      let data = this.currentUserInfor
      let arr = [{
        key: 'comName',
        label: this.$t('home.company'),
        val: data.comName
      }, {
        key: 'position',
        label: this.$t('home.post'),
        val: data.position
      }, {
        key: 'phone',
        label: this.$t('home.iphone'),
        val: data.mobile
      }, {
        key: 'email',
        label: this.$t('home.email'),
        val: data.email
      }]
      return arr
    },
    isInside () {
      if (process.env.VUE_APP_LOGIN_WAY !== '1') return true // 外网显示注销功能
      else return false // 内网不显示
    },
    pageMode () {
      return GetSearchValue('preview')
    }
  },
  methods: {
    changeLang (lang) {
      this.$i18n.locale = lang
      if (!this.$route.query.lang) {
        this.$router.push({
          query: {
            ...this.$route.query,
            lang
          }
        })
      }
    },
    goEditPwd () {
      window.open(this.editPwdUrl)
    },
    logout () {
      this.$sso.signOut()
    },
    login () {
      this.$store.dispatch('global/domainLogin')
    },
    reloadPage() {
      location.reload();
      window.scrollBy(0, -5000);
    }
  }
}

</script>
